export default "__VITE_ASSET__CqHar5QJ__"